import classNames from 'helpers/class-names'
import { FC } from 'react'

export type HeadingProps = {
  children: React.ReactNode
  className?: string
  level: 1 | 2 | 3 | 4 | 5 | 6
}

export const Heading: FC<HeadingProps> = ({ children, level, className }) => {
  if (level === 1) {
    return (
      <h1
        className={classNames('text-xl font-semibold leading-snug', className)}>
        {children}
      </h1>
    )
  }

  if (level === 2) {
    return (
      <h2
        className={classNames('text-lg font-semibold leading-snug', className)}>
        {children}
      </h2>
    )
  }

  if (level === 3) {
    return (
      <h3
        className={classNames(
          'text-xs font-bold uppercase text-gray-400 dark:text-gray-200',
          className,
        )}>
        {children}
      </h3>
    )
  }

  if (level === 4) {
    return (
      <h4 className={classNames('text-sm font-semibold', className)}>
        {children}
      </h4>
    )
  }

  if (level === 5) {
    return <h5 className={classNames(className)}>{children}</h5>
  }

  if (level === 6) {
    return <h6 className={classNames(className)}>{children}</h6>
  }

  return <>{children}</>
}
